import React from "react";
import femaleImage from '../assets/female.svg';
import maleImage from '../assets/male.svg';

const Banner = () => {
  return (
    <section className="relative bg-lightBlue-lightBlue overflow-hidden py-[36px] md:py-[72px]">
      <div className="container mx-auto px-4 relative">
        <div className="relative flex flex-col md:flex-row items-center justify-center text-center gap-4">

          {/* Left Image */}
          <div className="hidden md:block w-[280px] xl:w-[340px] shrink-0">
            <img
              src={femaleImage}
              alt="Free Mock Tests"
              width="340"
              height="296"
              className="block mx-auto"
              loading="lazy"
            />
          </div>

          {/* Center Content */}
          <div className="max-w-xl mx-auto">
            <h3 className="text-xl md:text-2xl font-semibold text-dark-600">Test Your Skills with</h3>
            <h1 className="text-3xl md:text-4xl font-bold text-red-600 mt-1">Free Mock Tests</h1>
          </div>

          {/* Right Image */}
          <div className="hidden md:block w-[280px] xl:w-[320px] shrink-0">
            <img
              src={maleImage}
              alt="Free Mock Tests"
              width="320"
              height="396"
              className="block mx-auto"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>

  );
};

export default Banner;
